import { render, staticRenderFns } from "./HJ0139.vue?vue&type=template&id=18c1687a&scoped=true&"
import script from "./HJ0139.vue?vue&type=script&lang=js&"
export * from "./HJ0139.vue?vue&type=script&lang=js&"
import style0 from "./HJ0139.vue?vue&type=style&index=0&id=18c1687a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1687a",
  null
  
)

export default component.exports